import { Injectable } from "@angular/core";
import { BaseStorageService } from "../../core/storage/base-storage.service";
import { OfflineTransaction } from "../../models/offline-transaction.model";

@Injectable({ providedIn: "root" })
export class OfflineTransactionStorageService extends BaseStorageService<OfflineTransaction> {
  protected override readonly storeName = "offline-transactions";
}
